export type InspectionState = {
    inspectionList:InspectionList[] | null
    selectedInspectionItem:InsepectionDetail |null
    excelDownloadStartDate:moment.Moment | Date |null;
    excelDownloadEndDate:moment.Moment | Date |null;
    questionList:ESSQuestionList[]
    subQuestionList:ESSSubQeustionList[]
    selected_inspection_id:number |null
    selected_parent_question_id:number|null
    selected_sub_question_List: ESSSubQeustionList[]|null
    selected_inspection:InspectionList|null

    
}

export interface ImageData {
      answer_id:number,
      create_date:string
    image: string;
    image_thumb: string;
    inspection_image_id: number;
    inspection_response_id:number
    is_further_action:number,
    parent_question:string,
    parent_question_id:number,
    sub_question:string

  }
  
  interface QAData {
    parenet_question_id: number;
    sub_question_id: number;
    parent_question: string;
    sub_question: string;
    answer: string[];
  }

  export interface InsepectionDetail {
    imageArray: ImageData[]|[];
    QAArray: QAData[]|[];
  }

 
  export interface ESSQuestionList{
    parent_question_id:number,
    parent_question:string,
    bin_type_id:number
  }

  export interface ESSSubQeustionList{
    sub_question_id:number,
    parent_question_id:number,
    sub_question:string,
    is_active:number
  }


  export interface InspectionList {
    inspection_id: number |null;
    enquiry_id: number |null;
    district_cn:string|''
    code:string|''
    bin_id: number |null;
    bin_type_id:number|null
    inspection_type_cn: string|'';
    bin_full_name: string|'';
    attendance_date: moment.Moment | Date |null;
    inspection_date: moment.Moment | Date |null;
    is_inspected:number|null;
    is_supervisory_team: number|null;
    remarks: string |'';
    EpdComment:string|''
    create_date: moment.Moment | Date |null;
    location_cn:string;
    is_approved?:number
    review_date?:string,
    reviewer?:string
    need_further_action?:number

  }


export const inspectionState:InspectionState={
    inspectionList:[],
    selectedInspectionItem:null,
    excelDownloadEndDate: null,
    excelDownloadStartDate:null,
    questionList:[],
    selected_inspection_id:null,
    selected_inspection:null,
    subQuestionList:[],
    selected_parent_question_id:null,
    selected_sub_question_List:[]


}